import React from 'react';
import { Col, FormProps, Row } from 'react-bootstrap';
import Button from '../Button';
import EditableAvatar from '../EditableAvatar';
import Radio from '../Radio';
import RadioGroup from '../Radio/RadioGroup';

export type AddEditBeneficiaryQAFormProps = FormProps &
  React.PropsWithRef<{
    formData: any;
    isForFamilyMember: boolean;
    handleClose: () => void;
    handleOnSubmit: (formData: any) => void;
  }>;

const AddEditBeneficiaryQAForm = ({
  isForFamilyMember,
  formData,
  handleClose,
  handleOnSubmit,
  ...props
}: AddEditBeneficiaryQAFormProps) => {

  const handleSubmitForm = (formData: any) => {
    handleOnSubmit({ ...formData, beneficiaryType: 'person' });
    handleClose();
  };

  const [answer1, setAnswer1] = React.useState<string | number>();
  const [answer2, setAnswer2] = React.useState<string | number>();

  const handleAnswer1Change = (e: string | number) => {
    setAnswer1(e);
  };

  const handleAnswer2Change = (e: string | number) => {
    setAnswer2(e);
  };

  return (
    <Col>
      <Row>
        <EditableAvatar size={'large'} name={`${formData.firstName} ${formData.lastName}`} variant={'static'}>
          <h4 className={'text-sm-24-lg-32  fw-bold'}>
            {formData.firstName} {formData.lastName}
          </h4>
        </EditableAvatar>
      </Row>
      <Col className="d-flex flex-column pt-12">
        <h6 className='pb-4'>
          Do you certify that your family member: {formData.firstName} {formData.lastName}
        </h6>
        <span className={'fw-light text-sub1 lh-xs pb-4'}>
          Is the family member your/your domestic partner’s biological child, stepchild, adopted child, 
          a child placed for adoption with you or a child for whom you’re obliged to provide health coverage 
          under a QMCSO or a National Medical Support Notice deemed to be a QMCSO?
        </span>
        <RadioGroup
          name={'with-labels'}
          value={answer1}
          onChange={handleAnswer1Change}
        >
          <Radio
            value={'answer-1-yes'}
            id={'x1'}
            label={'Yes'}
            className="mt-6"
          />
          <Radio
            value={'answer-1-no'}
            id={'x2'}
            label={'No'}
            className="mt-6"
          />
        </RadioGroup>
        <span className={'fw-light text-sub1 lh-xs mt-4 py-4'}>
          Primary dependent upon you for support?
        </span>
        <RadioGroup
          name={'with-labels2'}
          value={answer2}
          onChange={handleAnswer2Change}
        >
          <Radio
            value={'answer-2-yes'}
            id={'y1'}
            label={'Yes'}
            className="mt-6"
          />
          <Radio
            value={'answer-2-no'}
            id={'y2'}
            label={'No'}
            className="mt-6"
          />
        </RadioGroup>
      </Col>            
      <Row>
        <Col>
          <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
            <Button
              className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
              variant="primary-outline"
              onMouseDown={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="order-1 order-lg-2"
              onMouseDown={() => handleSubmitForm(formData)}
              disabled={!answer1 || !answer2}
            >
              Submit
            </Button>
          </section>
        </Col>
      </Row>
    </Col>
  );
};
export default AddEditBeneficiaryQAForm;
